import React, { Component } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import { apiErrorMessage } from "Helpers/ContentValidation";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import LeaderFormFields, {
  emptyLeader,
  textToBio,
} from "components/ContentForms/LeaderFormFields";

export default class AddLeader extends Component {
  state = {
    values: { ...emptyLeader },
    loading: false,
    notification: false,
    notiColor: "success",
    message: "",
    redirect: false,
    signin: false,
  };

  notify = (notiColor, message) => {
    this.setState({ notification: true, notiColor, message });
    setTimeout(() => this.setState({ notification: false, message: "" }), 4000);
  };

  handleChange = (name, value) =>
    this.setState((prev) => ({ values: { ...prev.values, [name]: value } }));

  handleSubmit = async (e) => {
    e.preventDefault();
    const { values } = this.state;

    if (!values.name.trim()) return this.notify("warning", "Name is required!");
    if (init() !== "success") return this.setState({ signin: true });

    this.setState({ loading: true });

    try {
      const response = await axios.post(Constants.postUrls.createLeader, {
        ...values,
        bio: textToBio(values.bio),
      });
      this.notify("success", response.data?.message || "Leader created!");
      setTimeout(() => this.setState({ redirect: true }), 1500);
    } catch (error) {
      this.setState({ loading: false });
      this.notify("warning", apiErrorMessage(error, "Failed to create leader"));
    }
  };

  render() {
    if (this.state.signin) return <Navigate to="/signin" replace />;
    if (this.state.redirect) return <Navigate to="/leaders" />;

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Add Leader
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <LeaderFormFields values={this.state.values} onChange={this.handleChange} />

                <Grid item sm={12} mt={2}>
                  <MDButton
                    variant="contained"
                    size="small"
                    color="info"
                    type="submit"
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? "Creating..." : "Create"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Leadership"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
              close={() => this.setState({ notification: false })}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
